import React, { useState } from "react";

// redux
import { useSelector } from "react-redux";

// icon
import { ReactComponent as MailIcon } from "../../../../assets/icons/imported/mail.svg";
import { ReactComponent as PhoneIcon } from "../../../../assets/icons/imported/phone.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/imported/edit.svg";

// styles
import Styles from "./profileTab.module.css";

// components
import Input from "../../../../components/Input/Input";
import Button from "../../../../components/Button/Button";
import { isoStringToDate } from "../../../helpers/localeDate";
import SelectLanguageCurrencyInput from "../../../../components/Input/SelectLanguageCurrencyInput/SelectLanguageCurrencyInput";

const inputStyle = {
  fontSize: 15
}

const inputContainerStyle = {
  margin: 0,
  flex: 1
}

function ProfileTab({ userData }) {
  const theme = useSelector((state) => state.theme.value)

  // State for edit modes
  const [isEditing, setIsEditing] = useState({
    contact: false,
    preferences: false
  })

  const toggleEdit = (section) => {
    setIsEditing(prev => ({
      ...prev,
      [section]: !prev[section]
    }))
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.card}>
        <div className={Styles.content}>
          <div className={Styles.tabContainer}>
            <h5>My Profile</h5>

            {/* personal information */}
            <div className={Styles.formSection}>
              <div className={Styles.sectionHeader}>
                <div>
                  <p>Personal Information</p>
                  <span>Fill out these details, and let's get this party started.</span>
                </div>
              </div>

              {/* first/last name inputs container */}
              <div className={Styles.inputsContainer}>
                <Input
                  inputLabel="First Name"
                  style={inputStyle}
                  containerStyle={inputContainerStyle}
                  variant="secondary"
                  value={userData.first_name ?? ""}
                  disabled={true}
                />
                <Input
                  inputLabel="Last Name"
                  style={inputStyle}
                  containerStyle={inputContainerStyle}
                  variant="secondary"
                  value={userData.last_name ?? ""}
                  disabled={true}
                />
              </div>
            </div>

            {/* contact information */}
            <div className={Styles.formSection}>
              <div className={Styles.sectionHeader}>
                <div>
                  <p>Contact Information</p>
                  <span>
                    We need to keep in touch with you, so we're gonna need your contact
                    information.
                  </span>
                </div>
                <Button
                  text={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {!isEditing.contact && <EditIcon width={14} height={14} />}
                      {isEditing.contact ? "Cancel" : "Edit"}
                    </span>
                  }
                  variant="dark"
                  style={{
                    minWidth: "60px",
                    width: "auto",
                    height: "32px",
                    fontSize: "12px",
                    padding: "8px 16px"
                  }}
                  onClick={() => toggleEdit('contact')}
                />
              </div>

              {/* email/number inputs container */}
              <div className={Styles.inputsContainer}>
                <Input
                  inputLabel="Email"
                  style={inputStyle}
                  containerStyle={inputContainerStyle}
                  variant="secondary"
                  value={userData?.email}
                  icon={<MailIcon width={18} />}
                  disabled={true}
                />
                <Input
                  inputLabel="Phone Number"
                  style={inputStyle}
                  containerStyle={inputContainerStyle}
                  variant="secondary"
                  value={
                    userData?.phones[0]?.number?.length && userData?.phones[0].number
                  }
                  icon={<PhoneIcon width={17} />}
                  disabled={!isEditing.contact}
                />
              </div>
            </div>

            {/* preferences section */}
            <div className={Styles.formSection}>
              <div className={Styles.sectionHeader}>
                <div>
                  <p>Preferences</p>
                  <span>Customize your language and currency settings.</span>
                </div>
                <Button
                  text={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {!isEditing.preferences && <EditIcon width={14} height={14} />}
                      {isEditing.preferences ? "Cancel" : "Edit"}
                    </span>
                  }
                  variant="dark"
                  style={{
                    minWidth: "60px",
                    width: "auto",
                    height: "32px",
                    fontSize: "12px",
                    padding: "8px 16px"
                  }}
                  onClick={() => toggleEdit('preferences')}
                />
              </div>

              {/* language/currency inputs container */}
              <div className={Styles.inputsContainer}>
                {/* language selector */}
                <SelectLanguageCurrencyInput
                  containerStyle={inputContainerStyle}
                  inputType="language"
                  disabled={!isEditing.preferences}
                />

                {/* currency selector */}
                <SelectLanguageCurrencyInput
                  containerStyle={inputContainerStyle}
                  inputType="currency"
                  disabled={!isEditing.preferences}
                />
              </div>
            </div>

            <div className={Styles.footerContainer}>
              <span>
                This account was created on{" "}
                {isoStringToDate(userData.created_at).date}{" "}
                {isoStringToDate(userData.created_at).time}
              </span>

              {/* buttons container */}
              <div>
                <Button
                  text="Cancel"
                  variant="dark"
                  style={{
                    whiteSpace: "nowrap"
                  }}
                />
                <Button
                  text="Save changes"
                  style={{
                    width: "180%"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileTab
